import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'antd';
import type { FormInstance } from 'antd';
import { authStyles } from 'layouts/auth';
import { paths } from 'routes/routes';
import styles from './register.module.scss';

/**
 * "Email này đã có tài khoản. Hãy đăng nhập hoặc dùng Quên mật khẩu." — hai cụm động từ là
 * link, mang sẵn email sang trang kia (qua state, không lên URL).
 */
export const EmailTakenAlert = ({ email }: { email: string }) => (
  <Alert
    type="error"
    showIcon
    className={authStyles.formAlert}
    message={
      <span className={styles.alertText}>
        Email này đã có tài khoản. Hãy{' '}
        <Link to={paths.login} state={{ email }}>
          đăng nhập
        </Link>{' '}
        hoặc dùng{' '}
        <Link to={paths.forgotPassword} state={{ email }}>
          Quên mật khẩu
        </Link>
        .
      </span>
    }
  />
);

// Chỉ tự đặt con trỏ khi màn rộng: trên điện thoại sẽ bật bàn phím che mất nửa trang.
export const isWideScreen = () => {
  try {
    return window.matchMedia('(min-width: 900px)').matches;
  } catch {
    return false;
  }
};

/** Đang có lỗi thì kiểm tra lại ngay khi gõ, để lỗi biến mất lúc người dùng sửa xong. */
export const revalidateIfInvalid = (form: FormInstance, changed: Record<string, unknown>) => {
  const invalid = Object.keys(changed).filter((name) => form.getFieldError(name).length > 0);
  if (invalid.length) form.validateFields(invalid).catch(() => undefined);
};

/** Số giây còn lại tới mốc `target` (ms), tự đếm lùi mỗi giây. */
export const useSecondsLeft = (target: number) => {
  const [now, setNow] = useState(() => Date.now());
  const running = target > now;

  useEffect(() => {
    if (!running) return undefined;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [running, target]);

  useEffect(() => {
    // Mốc mới (vừa gửi lại mã) → cập nhật ngay, không đợi nhịp kế tiếp.
    setNow(Date.now());
  }, [target]);

  return Math.max(0, Math.ceil((target - now) / 1000));
};
